export const NonRenewableKey = {
  ELECTRICITY_BOARD: 'electricityBoard',
  ELECTRICITY_TF: 'electricity',
  COST_TF: 'cost',
  STATUS: 'status',
  COMMENT: 'comment'
};
export const NonRenewableLabel = {
  ELECTRICITY_BOARD: 'Electricity Board',
  ELECTRICITY_TF: 'Electricity',
  COST_TF: 'Cost',
  STATUS: 'Status',
  COMMENT: 'Comment',
  STATUS_COMMENTS: 'Status & Comments'
};
